<template>
  <li
    v-bind="{ ...$props, ...$attrs }"
    class="d-flex align-stretch justify-space-between dppl-list-item px-0"
    @click="$emit('click', $event)"
  >
    <div class="inner-container">
      <div
        class="d-flex justify-start pl-0 py-2 pr-2 left-column"
      >
        <slot name="left" />
      </div>
      <div
        class="d-flex justify-end py-0 right-column pr-0"
      >
        <div class="right-slot">
          <slot name="right" />
        </div>
        <v-menu
          v-if="showMenu"
          open-on-hover
          close-on-content-click
          transition="slide-y-transition"
          :offset="[-15, -5]"
          location="bottom right"
          :open-delay="0"
          :close-delay="50"
        >
          <template #activator="{ props }">
            <div
              class="menu-container"
              v-bind="props"
            >
              <v-icon size="small" icon="$dots-vertical" />
            </div>
          </template>
          <slot name="menu-contents" />
        </v-menu>
      </div>
    </div>
  </li>
</template>

<script setup>
import { computed, useSlots } from 'vue';

const slots = useSlots();

defineEmits(['click']);

const showMenu = computed(() => Boolean(slots['menu-contents']?.()));
</script>

<style lang="less" scoped>
@import '@/less/mixins';

.dppl-list-item {
  min-height: 66px;
  height: 100%;
  width: 100%;
  border-bottom: 2px solid @stroke-default;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
}

.dppl-list-item:hover {
  box-shadow: 0px 10px 20px @bg-canvas;
  background: @white;
}

.inner-container {
  width: 100%;
  min-height: inherit;
  display: flex;
  justify-content: space-between;
}

.left-column {
  min-height: inherit;
}

.right-column {
  min-height: inherit;
}

.right-slot {
  min-height: inherit;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.menu-container {
  width: 54px;
  min-width: 54px;
  border-left: 2px solid @stroke-default;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .v-icon {
    color: @grey-500;
  }
}

.menu-container:hover .v-icon {
  color: @text-brand;
}

.v-menu__content {
  box-shadow: 0px 10px 20px @bg-canvas;
}
</style>
